export default __webpack_public_path__ + "static/media/play_arrow_black_48dp.2408f951.svg";